import React from "react";
import dogo from "../../assets/images/pictures/customer-footer.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CustomerStoriesFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="container-fluid container-fluid--background">
      <div className="container features-page__container features-page__container--footer px-md-0">
        <div className="row">
          <div className="col-sm-6">
            <h2 className="heading">{t("customer.note14")}</h2>
            <h4 className="subheading">{t("customer.note15")}</h4>
            <Link to="/contacts" className="btn-secondary" target="_blank">
              {t("customer.note16")}
            </Link>
          </div>
          <div className="col-sm-6">
            <img
              width="320"
              src={dogo}
              className="img-responsive"
              alt=""
              decoding="async"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerStoriesFooter;
